/*
 * mocks/api/voicemail.ts
 * Anvilo, Inc.
 *
 * This file contains voicemail API mocks
 *
 * Created by Artem Yefimenko on 10/08/2020
 * Copyright (c) 2020 Anvilo, Inc. All right reserved.
 */

import { mock } from "../axios";

const API_URL = "https://testing-webapp-api.talkroute.com/api/";

const GET_VOICEMAIL_BOXES_URL = "v1/voicemail/boxes";
const GET_VOICEMAIL_URL = "v1/voicemails";
const GET_VOICEMAIL_ITEM_URL = "";
const GET_VOICEMAIL_FILE_URL = "audiofiles/voicemessage/2409710.ogg";

export const mockedVoicemailBoxes = [
  {
    description: "Test Mailbox 1",
    id: 31870,
    message_count: 1
  },
  {
    description: "Test Mailbox 2",
    id: 31871,
    message_count: 1
  }
]

export const mockedVoicemails = [
  {
    caller_cname: "",
    caller_number: "16504519942",
    created: "2020-07-01T09:56:45+0000",
    display_transcript: false,
    duration: 47,
    id: 2409710,
    message_read: true,
    vm_box_id: 31870,
  },
  {
    caller_cname: "",
    caller_number: "16504519942",
    created: "2020-07-11T09:56:45+0000",
    display_transcript: false,
    duration: 47,
    id: 2409711,
    message_read: false,
    vm_box_id: 31871,
  }
];

mock.onGet(`${API_URL}${GET_VOICEMAIL_BOXES_URL}`).reply((request) => {
  return [
    200,
    {
      data: mockedVoicemailBoxes,
    },
  ];
});

mock.onGet(`${API_URL}${GET_VOICEMAIL_URL}`).reply((request) => {
  return [
    200,
    {
      data: mockedVoicemails,
    },
  ];
});

mock.onPut(/v1\/voicemails\/\d*\/read/g).reply((request) => {
  const voicemailId = Number(request.url?.split("/")[2]);
  const toReturn = mockedVoicemails.find(voicemail => voicemail.id===voicemailId);
  if(toReturn) toReturn.message_read = true;
  return [
    200,
    toReturn,
  ];
});

mock.onPut(/v1\/voicemails\/\d*\/unread/g).reply((request) => {
  const voicemailId = Number(request.url?.split("/")[2])
  const toReturn = mockedVoicemails.find(voicemail => voicemail.id===voicemailId);
  if(toReturn) toReturn.message_read = false;
  return [
    200,
    toReturn
  ];
});

mock.onGet(/v1\/voicemails\/\d*\/audio-url/g).reply(200, {
  url: "https://testing-webapp-api.talkroute.com/api/audiofiles/voicemessage/2409710.ogg",
});

mock.onGet(`${API_URL}${GET_VOICEMAIL_FILE_URL}`).reply(async (request) => {
  const audioUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/resources/mock/audio/2409710.oga`;
  const testImage = Buffer.from(await (await fetch(audioUrl)).arrayBuffer());
  return [200, testImage, { "content-type": "audio/ogg" }];
});
